// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewCompanyDetails_scrollable-content__q1l4q","card":"ViewCompanyDetails_card__yO+8o","ant-card-head-title":"ViewCompanyDetails_ant-card-head-title__GrvKk"};